import { create } from 'zustand';
import { OrderSource } from '../../types';

interface OrderSourcesState {
	orderSources: OrderSource[] | undefined | null;
	loading: boolean;
	setLoading: (loading: boolean) => void;
	setOrderSources: (orderSources: OrderSource[] | undefined | null) => void;
}

const useOrderSources = create<OrderSourcesState>((set) => ({
	orderSources: undefined,
	loading: true,
	setLoading: (loading: boolean) => set({ loading }),
	setOrderSources: (orderSources: OrderSource[] | undefined | null) => set({ orderSources }),
}));

export default useOrderSources;
